export default "__VITE_ASSET__CHE4k$7T__"